import React, { useState } from 'react';
import { useRoutes } from 'react-router-dom';

import './App.css';

import NoMatch from './features/NoMatch';
import Layout from './features/Layout';
import Home from './features/Home/Home';
import { AppContext } from './AppContext';
import Cookies from 'universal-cookie';
import FoldersHome from './features/Folder/FoldersHome';

const cookies = new Cookies();

function App() {
  const routes = [
    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        {
          path: '/projects/:id/*',
          element: <FoldersHome />
        }
      ]
    }
  ];

  // The useRoutes() hook allows you to define your routes as JavaScript objects
  // instead of <Routes> and <Route> elements. This is really just a style
  // preference for those who prefer to not use JSX for their routes config.
  const element = useRoutes(routes);

  const featureFlags = cookies.get('Unleashfeatureflags') || {};

  return (
    <AppContext.Provider
      value={{
        unleashFeatureFlags: featureFlags
      }}
    >
      <div className="App">{element}</div>
    </AppContext.Provider>
  );
}

export default App;
